var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.268 32.268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "image (1)",
    d: "M16.134 0a16.134 16.134 0 1016.134 16.134A16.13 16.13 0 0016.134 0zm0 6.224a6.343 6.343 0 016.384 6.394 6.237 6.237 0 01-12.471.26c-.374-4.269 3.586-6.654 6.087-6.654zm0 23.419a13.958 13.958 0 01-11.178-6.067c1.819-3.877 8.213-2.858 11.178-2.858s9.838-1.062 11.317 2.858a13.5 13.5 0 01-11.317 6.067z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.9dd9a6672ef20319596684a8d96e16d7.svg";
export { ForwardRef as ReactComponent };